import useMemberSettings from '../member/useMemberSettings';
import useDailyReportSettingsUpdate from './useDailyReportSettingsUpdate';
import useNestedSettingsUpdate from './useNestedSettingsUpdate';

export default function useDailyReportPreviewSettingsUpdate() {
  const memberSettings = useMemberSettings();
  return useNestedSettingsUpdate(
    useDailyReportSettingsUpdate(),
    memberSettings?.web?.features?.dailyProjectReport?.dailyReportPreviewSettings,
    'dailyReportPreviewSettings'
  );
}
